(ns app.front.view.application-wizard.navigation
  "Leaf namespace holding wizard/workspace navigation utilities.
  Kept separate from app.front.view.application-wizard.core to avoid a
  require cycle: workspace/header.cljs requires this and core.cljs also
  requires workspace/primary-actions (which transitively requires header).

  Also owns the wizard's local signal-handler table for UI-only FSM
  signals (guard-only transitions that must not be sent to the backend)
  so that both subs.cljs and core.cljs can reference it without a cycle."
  (:require [app.domain.application.model :as app-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.ui.select :as ui-select]
            [app.front.view.workspace.util :as ws-util]
            [core.front.event :refer [>evt]]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(defn wizard-allowed-for-workspace? [workspace]
  (and (= :workspace.state/application (:domain/state workspace))
       (#{app-model/initial-domain-state :state.application/pre-submit-payment}
        (-> workspace workspace-model/workspace-application :domain/state))
       (not (workspace-model/own-or-prior-pre-consultation workspace))))

(defn application-submitted? [workspace]
  (let [app-state (-> workspace workspace-model/workspace-application :domain/state)]
    (and app-state
         (not (#{app-model/initial-domain-state :state.application/pre-submit-payment} app-state)))))

(def ^:private page-switcher-values [:wizard :workspace])

(def renewal-overview-step-path "renewal-overview")

(rf/reg-event-fx ::select-page-view
  (fn [{:keys [db]} [_ workspace-id view]]
    {:route/push (p/assoc-if {:route  (case view
                                        :wizard :view/application-wizard-resume
                                        :workspace :view/workspace)
                              :params {:workspace-id workspace-id}}
                             :query (ws-util/search-origin-query-params (:route/match db)))}))

(defn page-switcher-view [{:keys [tr workspace-id current-view]}]
  [:div
   [ui-select/select
    {:id           (str "wizard-workspace-switcher-" workspace-id)
     :values       page-switcher-values
     :val->str     #(tr [(case %
                           :wizard :application-wizard/wizard
                           :workspace :application-wizard/workspace)])
     :on-change    #(when-not (= current-view %)
                      (>evt [::select-page-view workspace-id %]))
     :value        current-view
     :allow-empty? false
     :label-text   (tr [:application-wizard/view-selector])
     :hide-label   true}]])

(rf/reg-event-fx ::redirect-to-sign-off
  ;; Adds :wizard true so the sign-off view knows to return to the wizard on completion.
  (fn [_ [_ workspace-id]]
    {:route/push {:route  :view/sign-off
                  :params {:workspace-id workspace-id}
                  :query  {:wizard true}}}))

(def local-signal-handlers
  "UI-only FSM signals (guard-only transitions tagged :primary-action, which have no
  ::tk/to and no ::tk/actions) mapped to the wizard re-frame event that performs them.
  Sending these to the backend would be a no-op so they must be handled here instead.
  The wizard only offers a UI-only action if it appears in this map; see
  app.front.view.application-wizard.subs/wizard-actionable?."
  {:process.signal/sign-off-view ::redirect-to-sign-off})
